var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.291,
    height: 25.293,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.387 25.293H3.952A3.956 3.956 0 010 21.341V7.953A3.956 3.956 0 013.952 4h9.435a3.956 3.956 0 013.952 3.952v13.389a3.956 3.956 0 01-3.952 3.952zM3.952 5.977a1.978 1.978 0 00-1.976 1.976v13.388a1.978 1.978 0 001.976 1.976h9.435a1.978 1.978 0 001.976-1.976V7.953a1.978 1.978 0 00-1.976-1.976zm17.339 12.894V3.952A3.956 3.956 0 0017.339 0H6.373a.988.988 0 000 1.976h10.966a1.978 1.978 0 011.976 1.976v14.919a.988.988 0 101.976 0zm0 0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.67aacafd4a7046529f0c46eeb5355008.svg";
export { ForwardRef as ReactComponent };